import React from 'react';

const LogoIcon: React.FC = () => (
  <svg width="28" height="33" viewBox="0 0 28 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.293398 6.83782L7.20921 0H21.0304L27.9462 6.85861L9.39922 25.5431H27.6213L20.716 32.4017H6.88438L0 25.5327L18.8089 6.84822L0.293398 6.83782Z" fill="white" />
    <path d="M15.3613 22.4256H24.1738L27.6212 25.5431L18.5782 25.5327L15.3613 22.4256Z" fill="white" />
    <path d="M9.40976 6.83783L14.1146 11.5142L9.3888 16.1801L0.293457 6.83783H9.40976Z" fill="white" />
  </svg>
);

export default LogoIcon; 